import { progressPropsSchema } from '../component-catalog.js';
export const progressDefinition = {
    type: 'Progress',
    category: 'content',
    propsSchema: progressPropsSchema,
    isDataBacked: false,
    needsMeasuredDims: false,
    description: 'Progress indicator from 0 to 100. Props: value (required, 0-100), label?, color?, variant? ("bar" | "circle").',
};
//# sourceMappingURL=Progress.js.map